/*
import { reduxForm, SubmissionError } from "redux-form";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import * as actions from "../constants/actions";
import SignupForm from "../components/forms/SignupForm";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.signup({ values, resolve, reject }));
  }).catch(error => {
    throw new SubmissionError({ _error: error });
  });
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupForm);
const withTranslationComponent = withTranslation(["signup", "common"])(connectedComponent);
export default reduxForm({
  form: "signup",
  onSubmit
})(SignupForm);
*/
import { reduxForm, SubmissionError } from "redux-form";

import * as actions from "../constants/actions";
import SignupForm from "../components/forms/SignupForm";

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.signup({ values, resolve, reject }));
  }).catch(error => {
    throw new SubmissionError({ _error: error });
  });
};

export default reduxForm({
  form: "signup",
  onSubmit
})(SignupForm);



// WEBPACK FOOTER //
// ./src/containers/SignupForm.js